<template>
  <CContainer>
    <h3>Dependencias (Centros de Costo)</h3>
    <!-- <h6>
      Esta sección le permite conocer de las Dependencias o Centros de Costo creadas en la empresa y saber cuales estan habilitadas para la realización de pedidos.     
    </h6> -->
    <CCard
      class="bg-light border-0 mt-4 mb-1">
      <CCardBody>
        <CButton
          color="success"
          class="mr-2 d-inline-block"
          to="/cliente/archivo/dependencias/agregar">
          <CIcon class="" name="cil-plus"/>
          <span class="p-2 align-middle">Agregar</span>
        </CButton>
        <!-- <CDropdown
          color="dark"
          :caret="false"
          class="d-inline-block">
          <template v-slot:toggler>
            <CButton
                  color="dark">
                  <CIcon name="cil-cloud-download"/>
                  <span class="align-middle ml-2">Descargar</span>
                </CButton>
          </template>
          <CDropdownItem>
            <template v-slot:default>
              <json-excel
                :fields="fileFields"
                :data="items"
                name="dependencias.xls"
                class="w-100">
                Excel
              </json-excel>
            </template>
          </CDropdownItem>
          <CDropdownItem>
            <template v-slot:default>
              <json-excel
                :fields="fileFields"
                :data="items"
                type="csv"
                name="dependencias.csv"
                class="w-100">
                CSV
              </json-excel>
            </template>
          </CDropdownItem>
        </CDropdown> -->
      </CCardBody>
    </CCard>
    <CCard>
      <CCardBody class="p-3">
        <CDataTable
          :items="dependencies"
          :fields="fields"
          :tableFilter="{label: 'Buscar: ', placeholder:' '}"
          :items-per-page="itemsPerPage"
          hover
          pagination>
          <template #estado="{item}">
            <td align="center">
              <CIcon v-if="item.estado == 'A'" name="cil-smile" class="m-1 text-success" size="xl"/>
              <CIcon v-if="item.estado == 'I'" name="cil-sad" class="m-1 text-danger" size="xl"/>
            </td>
          </template>
          <template #dependencia="{item}">
            <td align="left">
              <h3>{{ item.dependencia }}</h3>
              <span>{{ item.responsable }}</span>
            </td>
          </template>
          <template #telefono="{item}">
            <td align="left">
              <div v-if="Boolean(item.telefono)"><CIcon name="cil-phone"/> {{ item.telefono }} - {{ item.extension }}</div>
              <div v-if="Boolean(item.telefono)"><CIcon name="cil-tag"/> {{ phoneType[item.tipo_Telefono] }}</div>
              <div v-if="Boolean(item.correo_Electronico)"><CIcon name="cil-envelope-closed"/> <a @click="event => event.stopPropagation()" :href="`mailto:${item.correo_Electronico}`">{{ item.correo_Electronico }}</a></div>
            </td>
          </template>
          <template #direccion="{item}">
            <td align="left">
              <div><i class="bi bi-geo-fill" style="height: 1rem; width: 1rem; display: inline-block;"></i> {{ item.direccion }}</div>
              <div v-if="Boolean(item.ciudad) && Boolean(item.departamento)"> <CIcon name="cil-map"/> {{ item.ciudad }} - {{ item.departamento }}</div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a
                href="#"
                @click="toggleDocument(item)"
                class="mb-2">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"></CIcon>
              </a>              
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex mx-4 flex-row-reverse">
                <CButton 
                  size="sm"
                  class="mb-2"
                  :block="false"
                  @click="tryDelete(item.id_Dependencia)">
                  <CIcon class="text-danger" name="cil-trash"></CIcon>
                </CButton>
                <CButton
                  size="sm"
                  class="mb-2"
                  :block="false"
                  @click="goTo(item, 'editar')">
                  <CIcon name="cil-pencil" class="text-warning"></CIcon>
                </CButton>
              </div>
              <div class="ml-4"><strong>Centro Costo: </strong>{{ item.codigo ? item.codigo : '' }}</div>
              <div class="ml-4"><strong>Pedidos: </strong><CBadge :color="item.habilitado_Pedidos === 'V' ? 'success' : 'danger'"> {{ item.habilitado_Pedidos === 'V' ? 'Activo' : 'Inactivo' }}</CBadge></div>
              <div class="ml-4"><strong>Presupuesto: </strong><CBadge :color="item.activar_Presupuesto === 'V' ? 'success' : 'danger'"> {{ item.activar_Presupuesto === 'V' ? 'Activo' : 'Inactivo' }}</CBadge></div>
              <div class="ml-4"><strong>Actualización: </strong>{{ item.ultima_Actualizacion ? moment(item.ultima_Actualizacion).format('DD/MM/YYYY HH:mm:ss') : '' }}</div>             
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination
          :activePage.sync="page"
          :pages="pageCount"
          size="sm"
          align="center"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />  

      </CCardBody>
    </CCard>
    <CModal
      title=""
      color="dark"
      :show.sync="confirmationModal"
      :centered="true"
      :closeOnBackdrop="false"
      :backdrop="true"
      >
      <template v-slot:header>
        <h4>Dependencias</h4>
      </template>
      <template v-slot:body-wrapper>
          <CContainer align="center" class="p-4">                    
              <p>
                  ¿Confirma que desea borrar esta dependencia?                   
              </p>
          </CContainer>

      </template>
      <template v-slot:footer>
        <CContainer  align="center">
          <CButton
            color="danger"
            square 
            class="mr-2 d-inline-block"
            @click="deleteDep()">
            Borrar
          </CButton>
          <CButton
            color="secondary"
            square 
            class="mr-2 d-inline-block"
            @click="confirmationModal=false">
            <span class="align-middle">Cancelar</span>
            <!-- <CIcon name="cil-x"/> -->
          </CButton>
        </CContainer>
      </template>
    </CModal>

    <CElementCover  v-show="loading"/>
  
  </CContainer>
</template>

<script>
  import moment from 'moment'
  import CONSTANTS from '../../../constants'
  import { borrarDependencia } from '../../../api'
  import { dataGridDependencias } from '../../../apiDataGrids'

  const fields = [
    { _style:'text-align:center;', key: 'dependencia'},
    // { _style:'text-align:center;', key: 'codigo' },
    // { _style:'text-align:center;', key: 'responsable' },
    { _style:'text-align:center;', key: 'telefono'},
    { _style:'text-align:center;', key: 'direccion'},
    // { key: 'habilitado_Pedidos', label: ''},
    { _style:'text-align:center;', key: 'estado', label: 'Estado' },
    { _style:'text-align:center;', key: 'info', label: '' }
  ]

  const fileFields = {
    "Responsable": "responsable",
    "Dependencia": "dependencia",
    "Establecimiento": "establecimiento",
    "Telefono": "telefono",
    "Extension": "extension",
    "Direccion": "direccion",
    "Ciudad": "ciudad",
    "Correo Electronico": "correo_Electronico",
    "Codigo": "codigo",
    "Habilitado Pedidos": "habilitado_Pedidos",
    "Activar Presupuesto": "activar_Presupuesto",
    "Estado": {
      field: "estado",
      callback(value){
        return (value === "A") ? "Activo" : "Inactivo"
      }
    }
  }

export default {
   name: 'Dependencies',
   data () {
    return {
      dependencies: [],
      phoneType: {
        'G': 'General',
        'T': 'Trabajo',
        'M': 'Móvil',
        'P': 'Personal',
        'F': 'Fax'
      },
      fields,
      fileFields,
      page: 1,
      pageCount: 1,
      itemsPerPage: 5,
      searchWord: '',
      dep2delete: '',
      confirmationModal: false,
      loading: false
    }
  },
  components:{
    // JsonExcel
  },
  methods:{
    moment,
    async getData(page, search) {
      this.loading = true
      
      try {

        const { count, results } = await dataGridDependencias(this,this .$store.state.user.data.id_Directorio, page, search);

        this.dependencies = results
        this.pageCount = parseInt(count / this.itemsPerPage)
        if (this.pageCount < (count / this.itemsPerPage)) {
          this.pageCount++
        } 
      } catch (error) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: 'Error al cargar datos',
          show: 5
        })
        
      } finally {
        this.loading = false
      }
    },
    tryDelete(id){
      this.dep2delete = id
      this.confirmationModal = true
    },
    async deleteDep(){
      try {
        this.confirmationModal = false
        this.loading = true
        await borrarDependencia(this, this.dep2delete)
        const itemIndex = this.dependencies.findIndex(it => it.id_Dependencia == this.dep2delete)
        this.dependencies.splice(itemIndex, 1)
        // this.$store.commit('set', ['dependencies', [...this.items]])
        this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
        })
      } catch (error) {
        console.log(error)
        this.$store.commit('setAlert', {
          color: "danger",
          message: CONSTANTS.messages.notDoneDelete,
          show: 5
        })
        
      } finally {
        this.loading = false
      }
    },
    goTo(item, destination) {
      this.$store.commit('set', ['selectedDependency', item])
      this.$router.push({
        path: `/cliente/archivo/dependencias/${destination}`
      })
    },
    toggleDocument(item){
      this.$set(item, '_toggled', !item._toggled)
      this.$nextTick(() => { })
    },
  }, 
  async mounted(){
    await this.getData()
  }
}
</script>